<template>
    <div
        class="color-element container px-0 d-flex flex-column flex-lg-row"
        :class="sideInfoDocked ? 'side-info-docked' : ''"
        v-clickoutside="enableScroll"
        @touchmove="touchmove"
        v-on:wheel.up="enableScroll"
        v-on:wheel.down="enableScroll"
        ref="element"
    >
        <div class="w-100">
            <div
                id="colorcircle__outerCanvas"
                class="w-100 colorworld__outerCanvas position-relative"
            >
                <canvas
                    id="colorcircle"
                    class="position-absolute top-0 left-0"
                    @mousemove="mousemove"
                    @click="clickIt"
                ></canvas>
                <div class="colorworld__outerCanvas__innerInfo position-absolute w-25 h-25 d-flex flex-column align-items-center justify-content-center">
                    <p
                        v-if="null != colorActive"
                        v-text="t('colorworld.color_number')"
                    ></p>
                    <h3
                        v-if="null != colorActive"
                        v-text="colorLists[colorListLoaded][colorActive].code"
                    ></h3>
                    <p v-if="null != colorListLoaded">
                        <span
                            v-text="fabricTypes[colorListLoaded].fabricClass"
                        ></span>
                    </p>
                </div>
                <div class='color-search-container position-absolute'>
                    <input type='tel' maxlength='3' pattern='[0-9]{3}' v-model='searchNumber' class='color-search-input' :placeholder='t("colorworld.color_search")' @wheel="$event.target.blur()" >
                    <Transition name='fade'>
                        <div class='error' v-show='searchError'>
                            {{ t('colorworld.color_search_error') }}
                        </div>
                    </Transition>
                </div>
            </div>
        </div>
        <div class="colorworld__sideInfo pt-2 pt-xl-0 pb-3 pb-xl-0 px-3 w-100 relative">
            <template v-if="null != colorActive">
                <div class="colorworld__sideInfo__imageContainer mt-5 mt-xl-0 position-relative">
                    <img
                        class="w-100 h-100 top-0 left-0 position-absolute"
                        :src="colorLists[colorListLoaded][colorActive].img"
                        loading="lazy"
                    >
                    <img
                        v-if="97 < colorLists[colorListLoaded][colorActive].uv_protection"
                        class="uvprotection position-absolute"
                        src="/img/uvprotection.png"
                        loading="lazy"
                    >
                </div>
                <div class="colorworld__sideInfo__text bg-light-grey">
                    <p
                        v-text="colorLists[colorListLoaded][colorActive].code"
                    ></p>
                    <h3
                        class="pt-1"
                        v-text="colorLists[colorListLoaded][colorActive].title"
                    ></h3>
                    <p
                        v-text="colorLists[colorListLoaded][colorActive].extra_description"
                        class="pt-3 pt-xl-4"
                    ></p>
                    <p
                        v-if="colorLists[colorListLoaded][colorActive].description"
                        class="pt-3 pt-xl-4"
                    >
                        <span
                            v-text="colorLists[colorListLoaded][colorActive].description"
                        ></span>
                    </p>
                    <div class="colorworld__sideInfo__text__attributes row pt-5 mx-0">
                        <div
                            v-if="colorLists[colorListLoaded][colorActive].uv_protection"
                            class="col-12 col-xl-6 d-flex px-0"
                        >
                            <p class="pr-2 pb-1">
                                <strong>{{ t('colorworld.uv_protection') }}:</strong>
                                <span
                                    v-text="colorLists[colorListLoaded][colorActive].uv_protection"
                                ></span>
                                <span>%</span>
                            </p>
                            <div
                                class="expandIcon"
                                @click="openPopup(); fabricClassTabs = 0;"
                            ></div>
                        </div>
                        <div
                            v-if="colorLists[colorListLoaded][colorActive].light_protection"
                            class="col-12 col-xl-6 d-flex px-0"
                        >
                            <p class="pr-2 pb-1">
                                <strong>{{ t('colorworld.color_realness') }}:</strong>
                                <span
                                    v-text="colorLists[colorListLoaded][colorActive].light_protection"
                                ></span>
                            </p>
                            <div
                                class="expandIcon"
                                @click="openPopup(); fabricClassTabs = 0;"
                            ></div>
                        </div>
                        <div
                            v-if="colorLists[colorListLoaded][colorActive].surface_weight"
                            class="col-12 col-xl-6 d-flex px-0"
                        >
                            <p class="pr-2 pb-1">
                                <strong>{{ t('colorworld.surface_weight') }}:</strong>
                                <span
                                    v-text="colorLists[colorListLoaded][colorActive].surface_weight"
                                ></span>
                                <span>g/m2</span>
                            </p>
                            <div
                                class="expandIcon"
                                @click="openPopup(); fabricClassTabs = 0;"
                            ></div>
                        </div>
                        <div
                            v-if="colorLists[colorListLoaded][colorActive].water_protection"
                            class="col-12 col-xl-6 d-flex px-0"
                        >
                            <p class="pr-2 pb-1">
                                <strong>{{ t('colorworld.water_resistance') }}:</strong>
                                <span
                                    v-text="colorLists[colorListLoaded][colorActive].water_protection"
                                ></span>
                            </p>
                            <div
                                class="expandIcon"
                                @click="openPopup(); fabricClassTabs = 0;"
                            ></div>
                        </div>
                        <div
                            v-if="colorLists[colorListLoaded][colorActive].fabricClass"
                            class="col-12 col-xl-6 d-flex px-0"
                        >
                            <p class="pr-2 pb-1">
                                <strong>{{ t('colorworld.fabric_classes') }}:</strong>
                            </p>
                            <div
                                class="fabricClassIcon"
                                :class="'fabricClass' + colorLists[colorListLoaded][colorActive].fabricClass"
                            ></div>
                        </div>
                    </div>
                </div>
                <div
                    @click="openPopup(); fabricClassTabs = 1;"
                    class="colorworld__sideInfo__text bg-light-grey mt-1 colorworld__sideInfo__text__lower d-flex justify-content-between align-items-center"
                >
                    <div class="d-flex align-items-center">
                        <div class="layerIcon"></div>
                        <div class="pl-4">
                            <h4>
                                <strong
                                    v-text="t('colorworld.glatz_covers')"
                                ></strong>
                            </h4>
                            <p
                                v-text="t('colorworld.get_more_info')"
                            ></p>
                        </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6.774" viewBox="0 0 5 6.774">
                        <path id="play-button" d="M10.43,3.254,5.753.028A.161.161,0,0,0,5.5.161V6.613a.161.161,0,0,0,.253.133L10.43,3.52a.161.161,0,0,0,0-.265Z" transform="translate(-5.5)"/>
                    </svg>
                </div>
            </template>
            <template v-else>
                <h3
                    v-text="t('colorworld.no_fabric')"
                ></h3>
            </template>
        </div>
        <div
            class="infosPopup position-fixed top-0 left-0 w-100 h-100 overflow-auto"
            :class="[fabricClassInfosPopupOpen ? 'show' : '']"
            @click="closeInfosPopup($event)"
        >
            <div class="w-100 min-vh-100 d-flex justify-content-center align-items-center">
                <div class="infosPopup__inner fabricClass container-small bg-white w-100 position-relative">
                    <button
                        @click="closePopup()" type="button"
                        class="closing d-block bg-light-grey"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14.811" height="14.811" viewBox="0 0 14.811 14.811">
                            <path id="close.2" d="M14.811.873,13.938,0,7.405,6.533.873,0,0,.873,6.533,7.405,0,13.938l.873.873L7.405,8.278l6.533,6.533.873-.873L8.278,7.405Z"></path>
                        </svg>
                    </button>
<!--                    <h2 class="pb-5"
                        v-text="t('colorworld.properties_fabric_class')"
                    ></h2>-->
                    <p
                        v-text="t('colorworld.context_fabric_class')"
                    ></p>
                    <div class="fabricClass__tabContainer">
                        <div class="d-flex justify-content-center pb-5 mb-2">
                            <div class="tabSwitcher d-flex">
                                <button
                                    @click="fabricClassTabs = 0"
                                    :class="[fabricClassTabs == 0 ? 'active' : '']"
                                    v-text="t('colorworld.properties')"
                                ></button>
                                <button
                                    @click="fabricClassTabs = 1"
                                    :class="[fabricClassTabs == 1 ? 'active' : '']"
                                    v-text="t('colorworld.info')"
                                ></button>
                            </div>
                        </div>
                        <div class="fabricClass__tabs position-relative">
                            <div
                                class="fabricClass__tabs__item overflow-auto"
                                :class="[fabricClassTabs == 0 ? 'active' : '']"
                            >
                                <div class="fabricClass__table row">
                                    <div class="col-3 px-0">
                                        <div class="d-flex align-items-center bg-white"></div>
                                        <div class="d-flex align-items-center bg-white"></div>
                                        <div class="d-flex align-items-center pl-4">
                                            <p>
                                                <span v-text="t('colorworld.material')"></span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center pl-4">
                                            <p>
                                                <span v-text="t('colorworld.surface_weight')"></span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center pl-4">
                                            <p>
                                                <span v-text="t('colorworld.staininghazards')"></span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center pl-4">
                                            <p>
                                                <span v-text="t('colorworld.color_realness')"></span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center pl-4">
                                            <p>
                                                <span v-text="t('colorworld.waterresistance')"></span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center pl-4">
                                            <p>
                                                <span v-text="t('colorworld.uv_protection')"></span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-3 px-0">
                                        <div class="d-flex align-items-end justify-content-center bg-white">
                                            <p class="recomendation">{{ t('colorworld.recomend') }}</p>
                                        </div>
                                        <div class="d-flex align-items-center bg-beige">
                                            <p class="w-100 d-flex justify-content-center align-items-center">
                                                <span
                                                    class="text-center d-block pr-3"
                                                    v-text="t('colorworld.fabric_class')"
                                                ></span>
                                                <span class="d-block fabricClassIcon fabricClassIcon--big fabricClass62"></span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center bg-beige">
                                            <p
                                                class="text-center w-100"
                                                v-text="t('colorworld.polyester-set5')"
                                            ></p>
                                        </div>
                                        <div class="d-flex align-items-center bg-beige">
                                            <p class="text-center w-100">300g/m2</p>
                                        </div>
                                        <div class="d-flex align-items-center bg-beige">
                                            <p
                                                class="text-center w-100"
                                                v-text="t('colorworld.dyed_filament-set5')"
                                            ></p>
                                        </div>
                                        <div class="d-flex align-items-center bg-beige">
                                            <p class="text-center w-100">
                                                {{ t('colorworld.level-set5-title') }}<br />
                                                {{ t('colorworld.level-set5-subtitle') }}
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center bg-beige">
                                            <p class="text-center w-100">> 350 mm</p>
                                        </div>
                                        <div class="d-flex align-items-center bg-beige">
                                            <p class="text-center w-100">> 98 %</p>
                                        </div>
                                    </div>
                                    <div class="col-3 px-0">
                                        <div class="d-flex align-items-center bg-white"></div>
                                        <div class="d-flex align-items-center">
                                            <p class="w-100 d-flex justify-content-center align-items-center">
                                                <span
                                                    class="text-center d-block pr-3"
                                                    v-text="t('colorworld.fabric_class')"
                                                ></span>
                                                <span class="d-block fabricClassIcon fabricClassIcon--big fabricClass58"></span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p
                                                class="text-center w-100"
                                                v-text="t('colorworld.polyester-set4')"
                                            ></p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p class="text-center w-100">250g/m2</p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p
                                                class="text-center w-100"
                                                v-text="t('colorworld.dyed_filament-set4')"
                                            ></p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p class="text-center w-100">
                                                {{ t('colorworld.level-set4-title') }}<br />
                                                {{ t('colorworld.level-set4-subtitle') }}
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p class="text-center w-100">> 150 mm</p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p class="text-center w-100">> 98 %</p>
                                        </div>
                                    </div>
                                    <div class="col-3 px-0">
                                        <div class="d-flex align-items-center bg-white"></div>
                                        <div class="d-flex align-items-center">
                                            <p class="w-100 d-flex justify-content-center align-items-center">
                                                <span
                                                    class="text-center d-block pr-3"
                                                    v-text="t('colorworld.fabric_class')"
                                                ></span>
                                                <span class="d-block fabricClassIcon fabricClassIcon--big fabricClass61"></span>
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p
                                                class="text-center w-100"
                                                v-text="t('colorworld.polyester-set2')"
                                            ></p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p class="text-center w-100">220g/m2</p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p
                                                class="text-center w-100"
                                                v-text="t('colorworld.dyed_filament-set2')"
                                            ></p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p class="text-center w-100">
                                                {{ t('colorworld.level-set2-title') }}<br />
                                                {{ t('colorworld.level-set2-subtitle') }}
                                            </p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p class="text-center w-100">> 100 mm</p>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <p class="text-center w-100">> 98 %</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center mt-3">
                                    <svg class="mr-1" xmlns="http://www.w3.org/2000/svg" width="13.829" height="13.829" viewBox="0 0 13.829 13.829">
                                        <g id="Border" fill="#f8f8f8">
                                            <path d="M 6.914713859558105 13.57942390441895 C 3.239783763885498 13.57942390441895 0.2500038743019104 10.58964347839355 0.2500038743019104 6.914713859558105 C 0.2500038743019104 3.239783763885498 3.239783763885498 0.2500038743019104 6.914713859558105 0.2500038743019104 C 10.58964347839355 0.2500038743019104 13.57942390441895 3.239783763885498 13.57942390441895 6.914713859558105 C 13.57942390441895 10.58964347839355 10.58964347839355 13.57942390441895 6.914713859558105 13.57942390441895 Z" stroke="none"/>
                                            <path d="M 6.914713859558105 0.5000038146972656 C 3.377634048461914 0.5000038146972656 0.5000038146972656 3.377634048461914 0.5000038146972656 6.914713859558105 C 0.5000038146972656 10.4517936706543 3.377634048461914 13.32942390441895 6.914713859558105 13.32942390441895 C 10.4517936706543 13.32942390441895 13.32942390441895 10.4517936706543 13.32942390441895 6.914713859558105 C 13.32942390441895 3.377634048461914 10.4517936706543 0.5000038146972656 6.914713859558105 0.5000038146972656 M 6.914713859558105 3.814697265625e-06 C 10.73360443115234 3.814697265625e-06 13.82942390441895 3.095824241638184 13.82942390441895 6.914713859558105 C 13.82942390441895 10.73360443115234 10.73360443115234 13.82942390441895 6.914713859558105 13.82942390441895 C 3.095824241638184 13.82942390441895 3.814697265625e-06 10.73360443115234 3.814697265625e-06 6.914713859558105 C 3.814697265625e-06 3.095824241638184 3.095824241638184 3.814697265625e-06 6.914713859558105 3.814697265625e-06 Z" stroke="none" fill="#e60014"/>
                                        </g>
                                        <path id="Icon" d="M33.916,5.78l-.091.37q-.407.161-.65.245a1.715,1.715,0,0,1-.564.084,1.125,1.125,0,0,1-.767-.241.779.779,0,0,1-.274-.611,2.161,2.161,0,0,1,.02-.294q.021-.15.066-.339L32,3.793q.045-.173.076-.327a1.422,1.422,0,0,0,.031-.282.435.435,0,0,0-.095-.321.537.537,0,0,0-.363-.091.951.951,0,0,0-.27.041c-.092.027-.171.054-.238.078l.091-.37q.334-.136.638-.232a1.909,1.909,0,0,1,.577-.1,1.1,1.1,0,0,1,.755.237.786.786,0,0,1,.265.615c0,.052-.006.144-.018.276a1.843,1.843,0,0,1-.068.362l-.338,1.2a3.18,3.18,0,0,0-.074.33,1.7,1.7,0,0,0-.033.28.4.4,0,0,0,.106.325.6.6,0,0,0,.37.086,1.068,1.068,0,0,0,.28-.043A1.563,1.563,0,0,0,33.916,5.78ZM34,.757a.7.7,0,0,1-.236.533.8.8,0,0,1-.569.22.814.814,0,0,1-.572-.22.7.7,0,0,1-.239-.533.706.706,0,0,1,.239-.535.845.845,0,0,1,1.142,0A.707.707,0,0,1,34,.757Z" transform="translate(-25.897 3.436)" fill="#e60014"/>
                                    </svg>
                                    <h4
                                        v-text="t('colorworld.recomendation')"
                                    ></h4>
                                </div>
                            </div>
                            <div
                                class="fabricClass__tabs__item"
                                :class="[1 == fabricClassTabs ? 'active' : '']"
                            >
                                <div class="fabricClass__accordion">
                                    <div v-for="(item, index) in fabricClassAccordionItems" :item="item" :key="index">
                                        <button
                                            class="fabricClass__accordion__item fabricClass__accordion__item--accordion d-flex justify-content-between align-items-center"
                                            :class="[item.active ? 'active' : '']"
                                            @click="setAccordionActive(item)"
                                        >
                                            <p
                                                class="pr-1 title"
                                                v-text="item.title"
                                            ></p>
                                            <svg class="plus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                <path d="M15.869,24.5V17.131H8.5V15.869h7.369V8.5h1.263v7.369H24.5v1.263H17.131V24.5Z" transform="translate(-8.5 -8.5)"/>
                                            </svg>
                                            <svg class="minus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                <path d="m 8.5,17.131 v -1.262 h 16 v 1.263 c -16,-0.001 0,0 -16,-0.001 z" transform="translate(-8.5,-8.5)" />
                                            </svg>
                                        </button>
                                        <div
                                            class="fabricClass__accordion__panel"
                                            :class="[item.active ? 'active' : '']"
                                        >
                                            <div v-html="item.content"></div>
                                        </div>
                                        <div class="mb-1"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="colorworld__sideInfo__paginationForMobile d-flex d-lg-none w-100"
            :class="sideInfoDocked ? '' : 'position-fixed'"
        >
            <div class="bg-light-grey w-100 d-flex d-lg-none">
                <div class="colorworld__sideInfo__paginationForMobile__img">
                    <img
                        class="w-100 h-100"
                        :src="colorLists[colorListLoaded][colorActive].img"
                        loading="lazy"
                    />
                </div>
                <div class="colorworld__sideInfo__paginationForMobile__info w-100 d-flex align-items-center justify-content-between">
                    <div class="colorworld__sideInfo__paginationForMobile__info__left">
                        <p
                            v-text="colorLists[colorListLoaded][colorActive].code"
                        ></p>
                        <h4
                            v-text="colorLists[colorListLoaded][colorActive].title"
                        ></h4>
                    </div>
                    <div class="colorworld__sideInfo__paginationForMobile__info__right d-flex">
                        <div @click="clickItMobile($event, -1)">
                            <svg width="15px" height="14.5px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436; transform: scale(-1, 1);" xml:space="preserve">
                                <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "/>
                            </svg>
                        </div>
                        <div @click="clickItMobile($event, +1)">
                            <svg class="ml-3" width="15px" height="14.5px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve">
                                <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FireI18n } from 'fire-js-i18n';
import Vue from "vue";
Vue.directive('clickoutside', {
    inserted: (el, binding, vnode) => {
        // assign event to the element
        el.clickOutsideEvent = function (event) {
            // here we check if the click event is outside the element and it's children
            if (!(el == event.target || el.contains(event.target))) {
                // if clicked outside, call the provided method
                vnode.context[binding.expression](event)
            }
        }
        // register click and touch events
        document.body.addEventListener('click', el.clickOutsideEvent)
        document.body.addEventListener('touchstart', el.clickOutsideEvent)
    },
    unbind: function (el) {
        // unregister click and touch events before the element is unmounted
        document.body.removeEventListener('click', el.clickOutsideEvent)
        document.body.removeEventListener('touchstart', el.clickOutsideEvent)
    },
    stopProp(event) {
        event.stopPropagation()
    },
});
export default {
    name: 'colorcricle',
    data: () => ({
        activeAccordion: null,
        pulloverInfosPopupOpen: false,
        fabricClassTabs: 0,
        fabricClassInfosPopupOpen: false,
        canvas: null,
        context: null,
        x: false,
        y: false,
        segmentWidth: null,
        pieAngle: null,
        pieAngleFabric: null,
        segmentDepth: null,
        lastInPath: null,
        colorListLoaded : 0,
        colorActive: 0,
        supportsPassiveletiable: false,
        wheelOpt: false,
        wheelEvent: ('onwheel' in document.createElement('body') ? 'wheel' : 'mousewheel'),
        fabricClassAccordionItems: [],
        segments: [],
        segmentItems: 0,
        segmentItemsTotal: 0,
        segmentSizePrime: 3,
        segmentSizeSec: 1,
        segmentActive: null,
        segmentItemsMin: 8,
        requestAnimationFrameId: null,
        sideInfoDocked: false,
        lengthMain: 1.11,
        lengthSub: 1.055,
        lengthDefault: 1,
        circle: 2 * Math.PI,
        innerCircle: .42,
        innerCircleMax: .58,
        outerCircle: .6278,
        outerCircleMax: 1,
        searchNumber: '',
        searchError: false,
        mouseOverSegment: null
    }),
    directives: {},
    mixins: [],
    props: {
        colorLists: Array,
        fabricTypes: Array,
        staticBlocks: Array,
    },
    watch: {
        searchNumber(old_val)
        {
            this.searchError = false;
            let parsed_val = parseInt(old_val, 10);

            if(parsed_val >= 0)
            {
                // since maxlength and max attribute are ignored by browsers we enforce the limit here ...
                if(parsed_val > 999)
                {
                    parsed_val = 999;
                    this.searchNumber = parsed_val;
                }

                let color_list_key = null;
                let color_val_key = null;

                this.colorLists.forEach(function(color_values, idx)
                {
                    color_values.forEach(function(color_data, color_idx)
                    {
                        if(color_data['code'] == parsed_val)
                        {
                            color_val_key = color_idx;
                            color_list_key = idx;
                        }
                    });
                });

                if(null !== color_list_key && null !== color_val_key)
                {
                    this.colorListLoaded = color_list_key;
                    this.colorActive = color_val_key;
                    this.initColorCircle();
                }
                else
                {
                    this.searchError = true;
                }
            }
        },
        mouseOverSegment(){
            this.colorActive = this.segments[this.mouseOverSegment];
            this.initColorCircle();
        },
        colorListLoaded() {
            this.initColorCircle();
        },
    },
    created() { },
    destroyed() { },
    mounted() {
        // console.log(this.colorLists)
        // console.log(this.fabricTypes)
        // console.log(this.staticBlocks)
        this.fabricClassAccordionItems = this.staticBlocks;
        this.supportsPassive();
        document.querySelector('#colorcircle').addEventListener('rollout', this.mousemoveFunc);
        window.addEventListener('scroll', this.manageScroll);
        this.initColorCircle();
        window.addEventListener('resize', this.initColorCircle);
        this.searchNumber = 523; //default champagne color
        setTimeout(() => {this.searchNumber = '';}, 100);
    },
    methods: {
        initColorCircle() {
            this.canvas = document.getElementById('colorcircle');
            let canvasOuterCanvas = document.getElementById('colorcircle__outerCanvas');
            this.canvas.width = canvasOuterCanvas.offsetWidth;this.drawSegment
            this.canvas.height = canvasOuterCanvas.offsetHeight;
            this.segmentDepth = this.canvas.width / 2.25;
            this.x = this.canvas.width / 2;
            this.y = this.canvas.height / 2;
            this.segmentWidth = 360 / this.colorLists[this.colorListLoaded].length;
            this.pieAngle = this.circle / this.colorLists[this.colorListLoaded].length;
            this.pieAngleFabric = this.circle / 100;
            this.context = this.canvas.getContext('2d');

            if (this.context) this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

            this.cutSegment(.115, 0, this.circle)
                .then(this.drawSegments.bind(this, null, null))
                .then(this.cutSegment.bind(this, this.outerCircle, 0, this.circle))
                .then(this.drawInnerCircle.bind(this, null, null));
        },
        manageScroll() {
            // this.sideInfoDocked = true;
            const element = this.$refs.element.getBoundingClientRect();
            const viewportBottom = window.scrollY + window.innerHeight;
            this.sideInfoDocked = !(0 < element.y + element.height - window.innerHeight);
            console.log(element.y + element.height - window.innerHeight, viewportBottom)
            // console.log(element, sideInfo, viewportBottom)
        },
        // Canvas ---------------------------------------------------------------------------------------------------
        cutSegment(segmentDepthMultiplier, startAngle, endAngle) {
            return new Promise((resolve, reject) => {
                this.context = this.canvas.getContext('2d');
                this.context.globalCompositeOperation = 'destination-out';
                this.context.beginPath();
                this.context.moveTo(this.x, this.y);
                this.context.arc(this.x, this.y, (this.segmentDepth * segmentDepthMultiplier), startAngle, endAngle, false);
                this.context.fill();
                this.context.globalCompositeOperation = 'source-over';
                resolve(true);
            });
        },
        getDynamicIndex(i) {
            const segmentItemsTotal = this.colorLists[this.colorListLoaded].length;
            const segementsMax = segmentItemsTotal - 1;
            const dynamicIndexPrev1 = i - 1 < 0 ? segementsMax : i - 1;
            const dynamicIndexNext1 = i + 1 < segmentItemsTotal ? i + 1 : 0;
            return [
                dynamicIndexPrev1,
                dynamicIndexNext1
            ];
        },
        drawSegment(segmentDepthMultiplier, angleLeft, angleRight, index, printShadow) {
            if (!this.colorLists[this.colorListLoaded][index]) return false;
            this.context.beginPath();
            this.context.moveTo(this.x, this.y);
            this.context.arc(
                this.x,
                this.y,
                (this.segmentDepth * segmentDepthMultiplier),
                (angleLeft * this.pieAngle),
                (angleRight * this.pieAngle),
                false
            );
            // console.log(index, angleLeft * this.pieAngle, angleRight * this.pieAngle);
            // this.context.lineWidth = (this.segmentDepth * segmentDepthMultiplier);
            const currentColor = this.colorLists[this.colorListLoaded][index]['hexCode'];
            this.context.fillStyle = currentColor;
            // if (printShadow) {
            //     this.context.shadowColor = "rgba(0, 0, 0, .2)";
            //     this.context.shadowBlur = 7;
            // } else {
            //     this.context.shadowColor = "transparent";
            // }
            this.context.fill();
            // this.context.lineWidth = 1;
            // this.context.strokeStyle = currentColor;
            // this.context.stroke();
        },
        drawColorWheel(activeSegmentIndex) {
            // Clean items
            for (let i = 0; i < this.segmentItemsTotal; i++) {
                this.cutSegment(1.3, (i - 1) * this.pieAngle, (i + 2) * this.pieAngle);
            }

            const active = this.segments[activeSegmentIndex] ? this.segments[activeSegmentIndex] : 0;
            const activeLeft = 0 <= active - 1 ? active - 1 : this.segmentItems - 1;
            const activeRight = active + 1 < this.segmentItems ? active + 1 : 0;
            // console.log(active, activeSegmentIndex, this.segments);
            this.segments = [];
            for (let i = 0; i < this.segmentItems; i++) {
                let addSegements = 0;

                // Main
                if (active === i) {
                    addSegements = this.segmentSizePrime + 1;

                // Sub right side
                } else if (activeRight === i) {
                    addSegements = this.segmentSizeSec + 1;

                } else if (activeLeft === i) {
                    addSegements = this.segmentSizeSec + 1;

                // Default body right side
                } else if (activeRight < i) {
                    addSegements = 1;

                // Default body left side
                } else {
                    addSegements = 1;
                }

                for (let ii = 0;  ii < addSegements; ii++) {
                    this.segments.push(i);
                }
            }

            // Manage swap over
            if (this.segmentItems < active + this.segmentSizePrime + 1) {
                const activeDiff = active + this.segmentSizePrime + 1 - this.segmentItems;
                const preprend = this.segments.splice(this.segments.length - activeDiff, this.segments.length);
                this.segments = [ ...preprend, ...this.segments ];
            }

            let printLeft = false;
            let printMain = false;
            let printRight = false;
            for (let i = 0; i < this.segments.length; i++) {
                const colorId = this.segments[i];

                if (active === colorId) {
                    if (printMain) continue;
                    printMain = true;

                    let iStart = null;
                    let iEnd = null;

                    for (let ii = 0; ii < this.segmentSizePrime + 1; ii++) {
                        if (null !== iStart && colorId !== this.segments[iStart]) break;
                        iStart = (0 <= i - ii ? i - ii : this.segments.length + i - ii);
                    }

                    for (let ii = 0; ii < this.segmentSizePrime + 1; ii++) {
                        if (null !== iEnd && colorId !== this.segments[iEnd]) break;
                        iEnd = i + ii < this.segments.length ? i + ii : i + ii - this.segments.length;
                    }

                    // console.log(colorId, this.segments.length, i, iStart, iEnd)

                    // Manuell adjustment to posit according to the crossover steps
                    // if (colorId === this.segments.length - this.segmentSizePrime - 4) iStart -= 1;
                    // if (colorId === this.segments.length - this.segmentSizePrime - 4) iEnd -= 1;
                    // if (colorId === this.segments.length - this.segmentSizePrime - 3) iEnd -= 1;
                    if (colorId === this.segments.length - (this.segmentSizePrime) - (this.segmentSizeSec + 1) - 1) iEnd -= 1;

                    this.drawSegment(
                        this.lengthMain,
                        (iStart + 1),
                        (iEnd + 1),
                        colorId,
                        true
                    );

                } else if (activeLeft === colorId) {
                    if (printLeft) continue;
                    printLeft = true;

                    this.drawSegment(
                        this.lengthSub,
                        (i + 0),
                        (i + this.segmentSizeSec + 1),
                        colorId,
                        true
                    );

                } else if (activeRight === colorId) {
                    if (printRight) continue;
                    printRight = true;

                    this.drawSegment(
                        this.lengthSub,
                        (i + 0),
                        (i + this.segmentSizeSec + 1),
                        colorId,
                        true
                    );

                } else {
                    this.drawSegment(
                        this.lengthDefault,
                        (i + 0),
                        (i + 1),
                        colorId,
                        true
                    );

                }
            }

            // console.log(active, this.segmentItemsTotal, this.segments)
        },
        drawSegments(offsetX, offsetY) {
            return new Promise((resolve, reject) => {
                this.segmentItems = this.colorLists[this.colorListLoaded].length;
                this.segmentItemsTotal = this.segmentItems + this.segmentSizePrime + (this.segmentSizeSec * 2);
                this.pieAngle = this.circle / (this.segmentItemsTotal);

                for (let i = 0; i < this.segments.length; i++) {
                    if (this.checkSegmentPath(
                        1,
                        (i + 0) * this.pieAngle,
                        (i + 1) * this.pieAngle,
                        offsetX,
                        offsetY
                    )) {
                        // console.log(offsetX, offsetY, this.segmentActive, this.segments[i])
                        if (this.segmentActive !== this.segments[i]) {
                            this.segmentActive = this.segments[i];

                            this.mouseOverSegment = i;

                            this.drawColorWheel(i);
                        }
                        return resolve(true);
                    }
                }

                for (let i = 0; i < this.segments.length; i++) {
                    if (this.colorActive === this.segments[i]) {
                        this.drawColorWheel(i);
                        return resolve(true);

                    }
                }

                this.drawColorWheel(this.colorActive);
                resolve(true);
            });
        },
        drawInnerCircle(offsetX, offsetY) {
            return new Promise((resolve, reject) => {
                let  lastFabricAngle = 0;

                for (let i = 0; i < this.fabricTypes.length; i++) {
                    let currentColor = '#f1f1f1';
                    const isActiveSegement = this.checkSegmentPath(
                        this.innerCircleMax,
                        lastFabricAngle,
                        lastFabricAngle + (this.fabricTypes[i].percentage * this.pieAngleFabric)-.075,
                        offsetX,
                        offsetY
                    );
                    if (i === this.colorListLoaded || isActiveSegement) {
                        currentColor = '#ffffff';
                        this.canvas.style.cursor = 'pointer';
                    }
                    this.context.shadowColor = "transparent";
                    this.context.beginPath();
                    this.context.moveTo(this.x, this.y);
                    this.context.arc(
                        this.x,
                        this.y,
                        this.segmentDepth * this.innerCircleMax,
                        lastFabricAngle,
                        lastFabricAngle + ((this.fabricTypes[i].percentage * this.pieAngleFabric) - .075),
                        false
                    );
                    this.context.fillStyle = currentColor;
                    this.context.fill();
                    currentColor = '#cccccc';
                    this.context.lineWidth = .5;
                    this.context.strokeStyle = currentColor;
                    this.context.lineTo(this.x, this.y);
                    this.context.stroke();
                    this.context.arc(
                        this.x,
                        this.y,
                        this.segmentDepth * .4225,
                        lastFabricAngle,
                        lastFabricAngle + ((this.fabricTypes[i].percentage * this.pieAngleFabric) - .075),
                        false
                    );
                    this.context.stroke();
                    lastFabricAngle = lastFabricAngle + (this.fabricTypes[i].percentage * this.pieAngleFabric);

                    const newPos = this.getPoint(
                        this.x,
                        this.y,
                        this.segmentDepth * .50125,
                        lastFabricAngle - (this.fabricTypes[i].percentage * this.pieAngleFabric / 2)
                    );
                    this.drawHexagon(
                        newPos[0],
                        newPos[1],
                        this.fabricTypes[i].fabricNumber,
                        i === this.colorListLoaded || isActiveSegement
                    );
                }
                this.context.globalCompositeOperation = 'destination-out'
                this.context.beginPath();
                this.context.moveTo(this.x, this.y);
                this.context.arc(this.x, this.y, (this.segmentDepth * this.innerCircle), 0, this.circle, false);
                this.context.fill();
                this.context.globalCompositeOperation = 'source-over';
                resolve(true);
            });
        },
        fabricIdMapping(fabricId) {
            switch(fabricId) {
                case 58: return 1;
                case 59: return 2;
                case 60: return 3;
                case 61: return 4;
                case 62: return 5;
            }
            return null;
        },
        drawHexagon(x, y, number, isActive) {
            let currentColor = '#4f4f4f';
            if (isActive) currentColor = '#E60014';
            const a = this.circle / 6;
            const r = this.canvas.width / 40;
            this.context.beginPath();
            for (let i = 0; i < 6; i++) {
                this.context.lineTo(x + r * Math.cos(a * i), y + r * Math.sin(a * i));
            }
            this.context.closePath();
            this.context.strokeStyle = currentColor;
            this.context.stroke();
            this.context.fillStyle = currentColor;
            // breakpoint
            if (window.innerWidth > 600) {
                this.context.font = "12px Arial";
                this.context.fillText(
                    this.fabricIdMapping(number),
                    x - 3,
                    y + 5
                );
            } else {
                this.context.font = "9px Arial";
                this.context.fillText(
                    this.fabricIdMapping(number),
                    x - 3,
                    y + 4
                );
            }
        },
        checkSegmentPath(segmentDepthMultiplier, startAngle, endAngle, offsetX, offsetY) {
            this.context.beginPath();
            this.context.moveTo(this.x, this.y);
            this.context.arc(this.x, this.y, (this.segmentDepth * segmentDepthMultiplier), startAngle, endAngle, false);
            return this.context.isPointInPath(offsetX, offsetY);
        },
        getPoint(c1, c2, radius, angle) {
            return [c1 + Math.cos(angle) * radius, c2 + Math.sin(angle) * radius];
        },
        // Helper ---------------------------------------------------------------------------------------------------
        t(key, options) {
            return FireI18n.t(key, options);
        },
        // Scroll-disable  ---------------------------------------------------------------------------------------------------
        supportsPassive() {
            let self = this;
            try {
                window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
                    get: function () { self.supportsPassiveletiable = true;}
                }));
            } catch(e) { }

            if (this.supportsPassiveletiable) {
                this.wheelOpt = { passive: false };
            } else {
                this.wheelOpt = false;
            }
        },
        disableScroll() {
            window.addEventListener('DOMMouseScroll', this.preventDefault, false); // older FF
            window.addEventListener(this.wheelEvent, this.preventDefault, this.wheelOpt); // modern desktop
            window.addEventListener('touchmove', this.preventDefault, this.wheelOpt); // mobile
            window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
        },
        enableScroll() {
            window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
            window.removeEventListener(this.wheelEvent, this.preventDefault, this.wheelOpt);
            window.removeEventListener('touchmove', this.preventDefault, this.wheelOpt);
            window.removeEventListener('keydown', this.preventDefaultForScrollKeys, false);
        },
        preventDefault(e) {
            e.preventDefault();
        },
        preventDefaultForScrollKeys(e) {
            if (keys[e.keyCode]) {
                preventDefault(e);
                return false;
            }
        },
        // Event ---------------------------------------------------------------------------------------------------
        accordionOpenClose(event) {
            if (event.target.classList.contains("active")) {
                event.target.nextElementSibling.classList.remove("active");
                event.target.classList.remove("active");
            } else {
                event.target.nextElementSibling.classList.add("active");
                event.target.classList.add("active");
            }
        },
        setAccordionActive(accordionItem) {
            this.fabricClassAccordionItems.map((item) => {
                if (accordionItem === item) return true;
                item.active = false;
                return true;
            });
            accordionItem.active = !accordionItem.active;
        },
        closePopup() {
            this.fabricClassInfosPopupOpen = false;
            document.body.classList.remove("overflow-hidden");
        },
        openPopup() {
            this.fabricClassInfosPopupOpen = true;
            document.body.classList.add("overflow-hidden");
        },
        closeInfosPopup(event) {
            if (event.target.classList.contains("infosPopup")) {
                this.fabricClassInfosPopupOpen = false;
                document.body.classList.remove("overflow-hidden");
            }
        },
        mousemoveFunc(event) {
            //this.canvas.style.cursor = 'default';

            if (!this.checkSegmentPath(
                this.outerCircle,
                0,
                this.circle,
                event.offsetX,
                event.offsetY
            )) {
                this.drawSegments(event.offsetX, event.offsetY)
                    .then(this.cutSegment.bind(this, this.outerCircle, 0, this.circle))
                    .then(this.drawInnerCircle.bind(this, event.offsetX, event.offsetY));
            }
        },
        touchmoveFunc(event) {
            let br = document.getElementById("colorcircle").getBoundingClientRect();
            let eventOffsetX = event.touches[0].clientX - br.left;
            let eventOffsetY = event.touches[0].clientY - br.top;
            //this.canvas.style.cursor = 'default';

            const segementLength = 1;
            if (!this.checkSegmentPath(
                segementLength,
                0,
                this.circle,
                eventOffsetX,
                eventOffsetY
            )) {
                this.enableScroll();

            } else {
                this.disableScroll();

            }

            if (!this.checkSegmentPath(
                this.outerCircle,
                0,
                this.circle,
                eventOffsetX,
                eventOffsetY
            )) {
                for (let i = 0; i < this.segmentItemsTotal; i++) {
                    if (this.checkSegmentPath(
                        1,
                        i * this.pieAngle,
                        (i + 1) * this.pieAngle,
                        eventOffsetX,
                        eventOffsetY)
                    ) this.colorActive = this.segments[i];
                }
                this.drawSegments(eventOffsetX, eventOffsetY)
                    .then(this.cutSegment.bind(this, this.outerCircle, 0, this.circle))
                    .then(this.drawInnerCircle.bind(this, eventOffsetX, eventOffsetY));

            } else {
                if (!this.checkSegmentPath(
                    this.innerCircle,
                    0,
                    this.circle,
                    eventOffsetX,
                    eventOffsetY
                )) {
                    this.drawSegments(eventOffsetX, eventOffsetY)
                        .then(this.cutSegment.bind(this, this.outerCircle, 0, this.circle))
                        .then(this.drawInnerCircle.bind(this, eventOffsetX, eventOffsetY));
                }
            }
        },
        mousemove(event) {
            window.cancelAnimationFrame(this.requestAnimationFrameId);
            this.requestAnimationFrameId = window.requestAnimationFrame(this.mousemoveFunc.bind(this, event));
        },
        touchmove(event) {
            window.cancelAnimationFrame(this.requestAnimationFrameId);
            this.requestAnimationFrameId = window.requestAnimationFrame(this.touchmoveFunc.bind(this, event));
        },
        clickIt(event) {
            // console.log('event clickit');
            // console.log(event);
            //this.canvas.style.cursor = 'default';

            if (!this.checkSegmentPath(
                this.outerCircle,
                0,
                this.circle,
                event.offsetX,
                event.offsetY
            )) {
                for (let i = 0; i < this.segments.length; i++) {
                    if (this.checkSegmentPath(
                        this.outerCircleMax,
                        (i + 0) * this.pieAngle,
                        (i + 1) * this.pieAngle,
                        event.offsetX,
                        event.offsetY
                    )) {
                        this.colorActive = this.segments[i];
                        break;
                    }
                }
            } else {
                if (!this.checkSegmentPath(
                    this.innerCircle,
                    0,
                    this.circle,
                    event.offsetX,
                    event.offsetY
                )) {
                    let lastFabricAngle = 0;
                    for (let i = 0; i < this.fabricTypes.length; i++) {
                        if (this.checkSegmentPath(
                            this.innerCircleMax,
                            lastFabricAngle,
                            lastFabricAngle + (this.fabricTypes[i].percentage * this.pieAngleFabric) - .075,
                            event.offsetX,
                            event.offsetY
                        )) {
                            if (this.colorListLoaded != i) {
                                this.colorListLoaded = i;
                                this.colorActive = 0;
                                this.lastInPath = null;
                                break;
                            }
                        }
                        lastFabricAngle = lastFabricAngle + (this.fabricTypes[i].percentage * this.pieAngleFabric);
                    }
                }
            }
        },
        clickItMobile(event, index) {
            //this.canvas.style.cursor = 'default';

            if (this.colorActive + index == this.colorLists[this.colorListLoaded].length) {
                this.colorActive = 0;

            } else if (this.colorActive + index < 0) {
                this.colorActive = this.colorLists[this.colorListLoaded].length - 1;

            } else {
                this.colorActive = this.colorActive + index;

            }

            this.drawSegments(event.offsetX, event.offsetY)
                .then(this.cutSegment.bind(this, this.outerCircle, 0, this.circle))
                .then(this.drawInnerCircle.bind(this, null, null));
        },
    }
};
</script>

<style lang="scss">
    @import "frontend/styles/framework";
    #colorcircle{
        width: 100%;
        height: 100%;
    }

    .infosPopup__inner {
        margin-top: 100px;
        margin-bottom: 50px;
    }
</style>